import { MAKERS } from "./passkey-makers-table.ts";

export type Said = {
  aaguid?: string | undefined;
  attachment?: string | undefined;
  transports?: string[] | undefined;
};

export function whoMade(said: Said): string {
  const known = said.aaguid ? MAKERS[said.aaguid] : undefined;
  if (known) return known;
  if (said.attachment === "platform") return "This device";
  const where = said.transports ?? [];
  if (where.includes("usb") || where.includes("nfc")) return "A security key";
  if (said.attachment === "cross-platform") return "Another device";
  if (where.length === 1 && where[0] === "internal") return "This device";
  return "A passkey";
}

export function howItIsHeld(said: Said): string | null {
  if (said.attachment === "platform") return "on this device";
  const where = said.transports ?? [];
  if (said.attachment === "cross-platform") {
    if (where.includes("usb")) return "plugged in";
    if (where.includes("nfc")) return "held to a reader";
    if (where.includes("ble")) return "over bluetooth";
    if (where.includes("hybrid")) return "on a phone or tablet";
    return "on another device";
  }

  if (where.length === 1 && where[0] === "internal") return "on this device";
  return null;
}

export function wasNamedByItsMaker(said: Said): boolean {
  return Boolean(said.aaguid && MAKERS[said.aaguid]);
}
